export default {"src":"/_next/static/media/parkeren.2107e3f5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};